import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

const formDataSchema = z.object({
  archiv: z.boolean()
})

type FormData = z.infer<typeof formDataSchema>

export default function useBfnOverviewFilters() {
  const form = useForm<FormData>({
    resolver: zodResolver(formDataSchema),
    defaultValues: { archiv: false }
  })
  const showArchiv = form.watch('archiv')

  return {
    form,
    showArchiv
  }
}
